<!--Copyright (c) PikPok. All rights reserved-->
<template>
  <v-container :fluid="true" class="ma-0 pa-0" v-if="loading">
    <v-row class="text-white bg-yellow-darken-3 pa-3 mt-0">
      <router-link to="/">
        <v-icon color="white" icon="mdi-less-than" size="x-large" class="pr-5 pl-5"></v-icon>
      </router-link>
      <v-icon color="white" icon="mdi-cog" size="x-large" class="pr-5 pl-5"></v-icon>
      <h3 class="pt-1">
        {{ bugReport.strings.BUG_TECHNICAL_ISSUE }}
      </h3>
    </v-row>
    <v-row v-if="!formSubmit">
      <v-col offset-lg="2" lg="8" offset="1" cols="10">
        <v-select
            v-model="formDetails.technical_and_live_issues"
            :items="bugReport.technical_and_live_issues"
            :rules="[v => !!v]"
            :label=bugReport.strings.BUG_TECHNICAL_ISSUE
            :placeholder=bugReport.strings.BUG_CHOOSE_OPTION
            required variant="solo-filled" return-object
        ></v-select>
        <v-form ref="form" lazy-validation v-if="!!formDetails.technical_and_live_issues">
          <v-text-field
              v-model="formDetails.in_game_username"
              :label=bugReport.strings.BUG_IN_GAME_USERNAME
              :placeholder=bugReport.strings.BUG_IN_GAME_USERNAME_HINT
              required
              variant="solo-filled"
              @blur="validateUsername"
          ></v-text-field>
          <v-text-field
              v-model="formDetails.email"
              :rules="[v => !!v, v => !v || /\s*\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})\s*/.test(v)]"
              :label=bugReport.strings.BUG_EMAIL
              :placeholder=bugReport.strings.BUG_EMAIL_HINT
              required variant="solo-filled"
          ></v-text-field>
          <v-select
              v-model="formDetails.game"
              :items="appList"
              :rules="[v => !!v]"
              :label=bugReport.strings.BUG_GAME
              :placeholder=bugReport.strings.BUG_CHOOSE_OPTION
              required variant="solo-filled"
          ></v-select>
          <v-select
              v-model="formDetails.platform"
              :items="bugReport.platforms"
              :rules="[v => !!v]"
              :label=bugReport.strings.BUG_PLATFORM
              :placeholder=bugReport.strings.BUG_CHOOSE_OPTION
              required variant="solo-filled"
          ></v-select>
          <v-textarea
              v-model="formDetails.description"
              :rules="[v => !!v]"
              :label=bugReport.strings.BUG_DESCRIPTION
              :placeholder=bugReport.strings.BUG_INFO
              required variant="solo-filled"
          ></v-textarea>
          <v-textarea
              v-model="formDetails.steps_to_reproduce"
              :rules="[v => !!v]"
              :label=bugReport.strings.BUG_STEPS_TO_REPRODUCE
              :placeholder=bugReport.strings.BUG_STEPS_TO_REPRODUCE_INFO
              required variant="solo-filled"
          ></v-textarea>
          <v-file-input
              v-model="files"
              :label=bugReport.strings.BUG_ATTACHMENTS
              multiple
              :rules=attachmentRules
              @change="onFilePicked"
              class="file-input-style"
              :key="fileUploadKey"
          >
            <template v-slot:selection="{ fileNames }">
              <v-chip
                  color="green"
                  variant="flat"
                  class="me-2"
                  size="small"
                  v-for="(fileName, index) in fileNames" :key="index"
                  label
                  closable
                  @click:close="deleteChip(fileName)">
                {{ fileName }}
              </v-chip>
            </template>
          </v-file-input>
          <!-- Extra Info -->
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-title class="text-subtitle-1 bg-amber-lighten-4">
                {{ bugReport.strings.BUG_EXTRA }}
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-text-field
                    v-model="formDetails.os"
                    :label="bugReport.strings.BUG_OPERATING"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.osversion"
                    :label="bugReport.strings.BUG_OS_VERSION"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.device"
                    :label="bugReport.strings.BUG_DEVICE_MODEL"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.locale"
                    :label="bugReport.strings.BUG_LOCALE"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.appname"
                    :label="bugReport.strings.BUG_APP_NAME"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.bundleversion"
                    :label="bugReport.strings.BUG_APP_VERSION"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.currentid"
                    :label="bugReport.strings.BUG_ID"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.memused"
                    :label="bugReport.strings.BUG_MEM_USED"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.memfree"
                    :label="bugReport.strings.BUG_MEM_FREE"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.totalmemused"
                    :label="bugReport.strings.BUG_TOTAL_MEM"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.uptime"
                    :label="bugReport.strings.BUG_UPTIME"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.steamid"
                    :label="bugReport.strings.BUG_STEAM"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.cpu"
                    :label="bugReport.strings.BUG_CPU"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.gpu"
                    :label="bugReport.strings.BUG_GPU"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.graphicsdriver"
                    :label="bugReport.strings.BUG_GRAPHICS"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.systemmem"
                    :label="bugReport.strings.BUG_SYSMEM"
                    readonly variant="solo-filled">
                </v-text-field>
                <v-text-field
                    v-model="formDetails.graphicsmem"
                    :label="bugReport.strings.BUG_GPUMEM"
                    readonly variant="solo-filled">
                </v-text-field>
                <p class="text-red" v-if="noShareWarning">
                  {{ bugReport.strings.BUG_NOSHARE }}
                </p>
                <v-btn
                    color="yellow-darken-3"
                    class="mt-4 text-white small-button-height"
                    block
                    @click="switchData"
                >
                  <span style="white-space: normal">
                    {{ shareExtraInfo ? bugReport.strings.BUG_NO_SHARE : bugReport.strings.BUG_SHARE }}
                  </span>
                </v-btn>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- Google Captcha -->
          <GoogleRecaptcha ref="recaptcha" @verify="onSubmit"></GoogleRecaptcha>
          <!-- Submit -->
          <v-btn
              color="yellow-darken-3"
              class="mt-4 mb-5 text-white"
              block
              @click="executeRecaptcha"
          >
            {{ bugReport.strings.BUG_SUBMIT }}
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
    <!-- Success or Error response after submit -->
    <v-row v-else class="mt-10">
      <v-col offset-lg="2" lg="8" offset="1" cols="10">
        <p v-if="error">{{ bugReport.strings.PRIVACY_ERROR }}</p>
        <p v-else v-html="bugReport.strings.BUG_THANKS_MESSAGE"></p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import GoogleRecaptcha from "@/components/Recaptcha";

export default {
  name: "TechnicalIssue",
  components: {GoogleRecaptcha},
  data() {
    return {
      formDetails: {},
      appList: [],
      loading: false,
      shareExtraInfo: true,
      noShareWarning: false,
      formSubmit: false,
      error: false,
      copyFormDetails: {},
      attachmentRules: [
        v => !v.some(file => file.size > 5242880) || 'File size should be less than 5MB',
        v => v.length <= 5 || 'Maximum number of files limit is 5'
      ],
      files: [],
      fileUploadKey: 0
    }
  },
  computed: {
    ...
        mapState({
          bugReport: state => state.supportStore.bugReport,
        }),
  },
  mounted() {
    this.getBugReport({
      params: {
        ...this.$route.query
      }
    }).then((response) => {
      this.loading = true
      this.formDetails = JSON.parse(JSON.stringify(response.data.form_details))
      this.formDetails.attachments = []
      response.data.appList.forEach(app => {
        this.appList.push({
          value: app[0],
          title: app[1],
        })
        // Contact us form - Set game name
        app[0].toLowerCase() == this.formDetails.game.toLowerCase()
            ? this.formDetails.game = app[0]
            : this.formDetails.game === '' && app[0].toLowerCase() == this.formDetails.appname.toLowerCase()
                ? this.formDetails.game = app[0] : null
      })
      // Contact us form - Set platform name
      this.formDetails.platform !== ""
          ? this.formDetails.platform = response.data.platforms.filter(p => p.value.toLowerCase() === this.formDetails.platform.toLowerCase())[0].value
          : this.formDetails.platform === "" && this.formDetails.os !== ""
              ? this.formDetails.platform = response.data.platforms.filter(p => p.value.toLowerCase() === this.formDetails.os.toLowerCase())[0].value
              : null
    })
  },
  methods: {
    switchData() {
      if (this.shareExtraInfo) {
        this.copyFormDetails = JSON.parse(JSON.stringify(this.formDetails))
        let newFormData = {
          os: '',
          osversion: '',
          device: '',
          locale: '',
          appname: '',
          bundleversion: '',
          currentid: '',
          memused: '',
          memfree: '',
          totalmemused: '',
          uptime: '',
          steamid: '',
          cup: '',
          gpu: '',
          graphicsmem: '',
          systemmem: '',
          graphicsdriver: ''
        }
        this.formDetails = {...this.formDetails, ...newFormData}
        this.noShareWarning = true
      } else {
        this.formDetails = {
          ...this.copyFormDetails,
          name: this.formDetails.name,
          email: this.formDetails.email,
          subject: this.formDetails.subject,
          game: this.formDetails.game,
          platform: this.formDetails.platform,
          description: this.formDetails.description
        }
        this.noShareWarning = false
      }
      this.shareExtraInfo = !this.shareExtraInfo
    },

    async onSubmit(result) {
      const {valid} = await this.$refs.form.validate()
      if (valid) {
        this.postBugReport({
          data: {
            ...this.formDetails,
            grecaptchaResponse: result,
            formType: 'technical_and_live_issues'
          }
        }).then((response) => {
          this.formSubmit = true
          this.error = response.data.error
        })
      } else {
        // Scroll to first error field
        this.$nextTick(() => {
          let topOfElement = document.querySelector('.v-field--error.v-field--error:first-of-type').offsetTop - 100
          window.scroll({top: topOfElement, behavior: "smooth"})
        })
      }
    },

    executeRecaptcha() {
      this.$refs.recaptcha.execute()
    },

    onFilePicked(event) {
      this.formDetails.attachments = []
      for (let i = 0; i < event.target.files.length; i++) {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[i])
        reader.onload = () => {
          this.formDetails.attachments.push({
            data: reader.result.split(',')[1],
            name: event.target.files[i].name,
            content_type: event.target.files[i].type
          })
        }
      }
    },

    deleteChip(fileName) {
      this.formDetails.attachments = this.formDetails.attachments.filter(file => file.name !== fileName)
      this.files = this.files.filter(file => file.name !== fileName)
      this.fileUploadKey += 1
    },

    validateUsername() {
      let blocked = ['n/a', 'na']
      let val = (this.formDetails.in_game_username || '').trim().toLowerCase()
      if (blocked.includes(val)) {
          this.formDetails.in_game_username = ''
      }
    },

    ...mapActions([
      'getBugReport',
      'postBugReport'
    ])
  }
}
</script>

<style scoped lang="scss">
@media only screen and (max-width: 550px) {
  .small-button-height {
    height: 70px;
  }
}

//:deep .file-input-style .v-field__field {
//  height: 60px !important;
//}

:deep .file-input-style .v-field__input {
  position: relative !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 2 !important;
}
</style>
